import { CoreBox, CoreTooltip, CoreTypography } from '@youscience/core';
import { FormActionsStatus, FormNames, TeacherRecommendationStatus } from '@youscience/commonapp-service-common';

import { Chip } from '@components/Chip';
import { STATUS_CHIP_COLORS } from '@constants/recommenderWorkspace';

import { renderInfoItem } from '@pages/StudentDetailsPage/components/SchoolCard/components/SchoolCardHeader';
import FormActionButtons from '@pages/StudentDetailsPage/components/FormActionButtons';

import InfoIcon from '@images/info.svg?react';
import FlagIcon from '@images/sports-score.svg?react';

import {
  sxStyles,
  StyledContainer,
  StyledFormHeader,
  StyledFormHeaderLeft,
  StyledStatusBar,
} from './FormHeader.styles';
import { FormCompletionStatus } from '../enums';

export interface FormHeaderProps {
  name: string;
  tooltipTitle: string;
  deadline?: string;
  collegeName?: string;
  status: FormActionsStatus | TeacherRecommendationStatus | FormCompletionStatus;
  onPreviewClick: () => void;
  onSaveForLaterClick: () => void;
  onSubmitClick: () => void;
  onUnsubmitClick: () => void;
  areAllActionsDisabled?: boolean;
  isSubmitDisabled?: boolean;
  isFormSumbitted: boolean;
  formName: FormNames;
}

export const FormHeader = (props: FormHeaderProps) => {
  const {
    name,
    tooltipTitle,
    deadline,
    collegeName,
    status,
    onPreviewClick,
    onSaveForLaterClick,
    onSubmitClick,
    onUnsubmitClick,
    formName,
    areAllActionsDisabled,
    isSubmitDisabled,
    isFormSumbitted,
  } = props;

  return (
    <StyledContainer>
      <StyledFormHeader>
        <StyledFormHeaderLeft>
          <CoreTypography variant="h4">{name}</CoreTypography>

          <CoreTooltip title={tooltipTitle}>
            <CoreBox sx={sxStyles.tooltip}>
              <InfoIcon />
            </CoreBox>
          </CoreTooltip>
        </StyledFormHeaderLeft>

        <FormActionButtons
          onPreviewClick={onPreviewClick}
          onSaveForLaterClick={onSaveForLaterClick}
          onSubmitClick={onSubmitClick}
          onUnsubmitClick={onUnsubmitClick}
          areAllActionsDisabled={areAllActionsDisabled}
          isSubmitDisabled={isSubmitDisabled}
          isFormSumbitted={isFormSumbitted}
          formName={formName}
        />
      </StyledFormHeader>

      <StyledStatusBar>
        <Chip title={status} color={STATUS_CHIP_COLORS[status]} size="medium" />

        {collegeName ? (
          <CoreBox sx={sxStyles.flexPosition}>
            <CoreTypography sx={sxStyles.infoItemTitle} variant="subtitle2" component="h4">
              College
            </CoreTypography>

            <CoreTypography sx={sxStyles.infoItemValue} variant="body2">
              {collegeName}
            </CoreTypography>
          </CoreBox>
        ) : null}

        {deadline ? (
          <>
            <CoreBox sx={sxStyles.infoItemDivider} />

            {renderInfoItem('Deadline', deadline, <FlagIcon />)}
          </>
        ) : null}
      </StyledStatusBar>
    </StyledContainer>
  );
};
